import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken, getUser, setUser, removeUser, getPermissions, setPermissions, removePermissions } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken() || '',
    user: getUser() || null,
    permissions: getPermissions()
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    SET_USER(state, user) {
      state.user = user
      setUser(user)
    },
    SET_PERMISSIONS(state, perms) {
      state.permissions = perms || []
      setPermissions(perms)
    },
    LOGOUT(state) {
      state.token = ''
      state.user = null
      state.permissions = []
      removeToken()
      removeUser()
      removePermissions()
    }
  },
  actions: {
    login({ commit }, { token, user, permissions }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
      commit('SET_PERMISSIONS', permissions || [])
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentUser: state => state.user,
    hasPermission: state => code => state.permissions.includes(code)
  }
})
